import React from 'react';
import { Building2, Calendar, ExternalLink, Users } from 'lucide-react';

const LocationsEspaces = () => {
    return (
        <div className="locations-espaces-page">
            {/* Hero Section */}
            <section className="bg-light py-5">
                <div className="container py-3">
                    <div className="row align-items-center">
                        <div className="col-lg-8 mx-auto text-center">
                            <h1 className="display-4 fw-bold mb-4">
                                LOCATIONS <span className="text-warning">D'ESPACES</span>
                            </h1>
                            <p className="fs-5 text-muted mb-4">
                                Le Mémorial ACTe met à votre disposition ses espaces pour vos événements professionnels et privés.
                                Découvrez nos salles et réservez en ligne.
                            </p>
                        </div>
                    </div>

                    {/* Features */}
                    <div className="row mt-5 g-4">
                        <div className="col-md-4">
                            <div className="text-center">
                                <div className="bg-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                                    <Building2 size={32} className="text-white" />
                                </div>
                                <h3 className="fs-5 fw-bold">Espaces modulables</h3>
                                <p className="text-muted">Salles adaptées à tous types d'événements</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-center">
                                <div className="bg-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                                    <Calendar size={32} className="text-white" />
                                </div>
                                <h3 className="fs-5 fw-bold">Réservation en ligne</h3>
                                <p className="text-muted">Consultez les disponibilités et réservez facilement</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-center">
                                <div className="bg-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                                    <Users size={32} className="text-white" />
                                </div>
                                <h3 className="fs-5 fw-bold">Accompagnement</h3>
                                <p className="text-muted">Notre équipe vous accompagne dans votre projet</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Réservation Section */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <a
                                href="https://mariloo.com/etablissement/macte?onglet=espaces"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-warning btn-lg fw-bold px-5 py-3 d-inline-flex align-items-center gap-2"
                            >
                                Voir les espaces et réserver
                                <ExternalLink size={20} />
                            </a>
                            <p className="text-muted small mt-3 mb-0">
                                Réservation via notre partenaire Mariloo
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LocationsEspaces;
